import type { UsageProfileFragment } from "@/v2-backoffice-client/usage/__types__/usage.fragment"
import type { UsageAppMixEntry } from "@/v2-backoffice-client/usage/UsageAppMix"

/** The profile's per-product split in the shape the mix bar and stories read. */
export function deriveUserAppMix(
  profile: UsageProfileFragment,
): UsageAppMixEntry[] {
  return profile.AppMix.map((entry) => ({
    app: entry.App,
    weighted28d: entry.Weighted28d,
    events28d: entry.Events28d,
    trendPct: entry.TrendPct,
    lastActiveAt: entry.LastActiveAt,
  }))
}
